import React from "react";
import { ROUTES } from "utils/constants";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AppSubHeader from "./AppSubHeader";

const SubHeader = () => {
    return (
        <div className="top-block">
            <div className="row align-items-center py-2">
                <AppSubHeader />
            </div>
        </div>
    );
};


const AppHeader = (props) => {

    const { data } = useSelector((state) => state.projects);

    const location = useLocation();
    const isProjectsPage = location.pathname === "/" + ROUTES.PROJECT;

    return (
        <>
            {isProjectsPage && (
                data && data.length > 0 ?
                    (<SubHeader />)
                    :
                    (<div className="bg-lgrey add-project-page">
                        <div className="content">
                            <div className="top-block">
                                <div className="container-fluid py-3 px-lg-5">
                                    <div className="row align-items-center">
                                        <div className="col-5 col-sm-2 mx-auto text-center text-md-start mb-2 mb-sm-0">
                                            <NavLink
                                                to={"/" + ROUTES.LOGIN}
                                                // className="navbar-brand d-flex align-content-center py-0 ms-0"
                                                role="tab"
                                                data-toggle="tab"
                                            >
                                                <img src="/assets/images/cloud-logo-black.svg" alt="" className="img-fluid" />
                                            </NavLink>

                                        </div>
                                        <AppSubHeader />
                                    </div>
                                </div>
                            </div>
                            {props.childComponent}
                        </div>
                    </div>)
            )
                || (<SubHeader />)
            }

        </>
    );
};

AppHeader.propTypes = {};

export default AppHeader;
